import { TypeMetadata } from "./TypeMetadata";
var JsonDataWithSchema = /** @class */ (function () {
    function JsonDataWithSchema(dataWithSchema, dereference) {
        if (dereference === void 0) { dereference = true; }
        if (dereference) {
            JsonDereferencer.dereference(dataWithSchema.data);
        }
        this.data = dataWithSchema.data;
        if (dataWithSchema.jsonSchema.basicType) {
            this.jsonSchema = dataWithSchema.jsonSchema;
        }
        else {
            this.jsonSchema = TypeMetadata.create(dataWithSchema.jsonSchema);
        }
    }
    /**
     * Selects the first list as the new root.
     * Returns the current instance if the root is already a list.
     */
    JsonDataWithSchema.prototype.selectFirstList = function () {
        if (this.jsonSchema.customType) {
            if (this.jsonSchema.basicType === "object") {
                var childListProperty = this.jsonSchema.customType.childListProperties[0];
                if (childListProperty) {
                    return new JsonDataWithSchema({
                        data: this.data[childListProperty.propertyName],
                        jsonSchema: childListProperty.type
                    }, false);
                }
            }
            else if (this.jsonSchema.basicType === "array") {
                return this;
            }
        }
        throw Error("Root type has no child lists, or is not a complex object.");
    };
    return JsonDataWithSchema;
}());
export { JsonDataWithSchema };
/**
 * Iterates object graphs with { $ref } pointer objects, and replaces them with the referenced object instances.
 */
var JsonDereferencer = /** @class */ (function () {
    function JsonDereferencer() {
        this.refs = {};
    }
    /**
     * Iterates object graphs with { $ref } pointer objects, and replaces them with the referenced object instances.
     */
    JsonDereferencer.dereference = function (data) {
        var dereferencer = new JsonDereferencer();
        dereferencer.dereference(data);
    };
    JsonDereferencer.prototype.dereference = function (data) {
        this.dereferenceInternal(data, function () { throw Error("Top level item cannot be a $ref object"); });
    };
    JsonDereferencer.prototype.dereferenceInternal = function (data, replace) {
        if (data !== null && data !== undefined) {
            if (data instanceof Array) {
                this.dereferenceArray(data);
            }
            else if (data instanceof Object && !(data instanceof Date)) {
                this.dereferenceObject(data, replace);
            }
        }
    };
    JsonDereferencer.prototype.dereferenceArray = function (list) {
        var _loop_1 = function (i) {
            this_1.dereferenceObject(list[i], function (dereferenced) { return list[i] = dereferenced; });
        };
        var this_1 = this;
        for (var i = 0; i < list.length; i++) {
            _loop_1(i);
        }
    };
    JsonDereferencer.prototype.dereferenceObject = function (object, replace) {
        if (object.hasOwnProperty("$id")) {
            this.refs[object["$id"]] = object;
        }
        if (object.hasOwnProperty("$ref")) {
            replace(this.refs[object["$ref"]]);
        }
        else {
            var _loop_2 = function (propertyKey) {
                if (object.hasOwnProperty(propertyKey)) {
                    var value = object[propertyKey];
                    this_2.dereferenceInternal(value, function (dereferenced) { return object[propertyKey] = dereferenced; });
                }
            };
            var this_2 = this;
            for (var propertyKey in object) {
                _loop_2(propertyKey);
            }
        }
    };
    return JsonDereferencer;
}());
